import { initializeApp } from "firebase/app";
import { getFirestore, 
    doc, setDoc, getDocs,
    query, where, collection } from "firebase/firestore";
import { getAuth} from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { firebaseConfig } from "./firebaseConfig";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import imageConversion from 'image-conversion';


// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Inicializa Firestore
const db = getFirestore(app);

// Inicializa Auth
const auth = getAuth(app);

// Opcional: Inicializa Firebase Analytics
const analytics = getAnalytics(app);

// Create a root reference
const storage = getStorage();

//funciones para el manejo de la base de datos

/** 
*   Función que obtiene el servicio de un colaborador
*   @param {string} userId id del usuario
*   @returns {object} retorna el servicio del usuario
*/
export const getServicio = async (userId) => {
    try {
        // obtenemos los servicios que posean el id del usuario, no es el id del servicio
        const servicios = collection(db, "servicios");
        const q = query(servicios, where("userId", "==", userId));
        const querySnapshot = await getDocs(q);
        let servicio = null;
        querySnapshot.forEach((doc) => {
            servicio = doc.data();
            servicio.id = doc.id;
        });
        return servicio;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}

/**
 * Función que crea un servicio
 * @param {string} userId el Id del usuario que crea un servicio
 * @param {string} name nombre del servicio
 * @param {string} description descripción del servicio
 * @param {string} price precio del servicio
 * @param {string} image localización de la imagen del servicio
 * @returns {boolean} retorna verdadero si creo el servicio
 */
export const createServicio = async (userId, name, description, price, image) => {
    try {
        const servicios = collection(db, "servicios");
        const newServicio = await setDoc(doc(servicios), {
            userId: userId,
            name: name,
            description: description,
            price: price,
            image: image
        });
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}


/**
 * Función que actualiza la información de un servicio
 * @param {string} servicioId id del servicio
 * @param {string} name nombre del servicio
 * @param {string} description descripción del servicio
 * @param {string} price precio del servicio
 * @param {string} image localización de la imagen del servicio
 * @returns {boolean} retorna verdadero si actualizo el servicio
 */
export const updateServicio = async (servicioId, name, description, price, image) => {
    try {
        const servicioRef = doc(db, "servicios", servicioId);
        await setDoc(servicioRef, {
            name: name,
            description: description,
            price: price,
            image: image
        }, { merge: true });
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}

/**
 * Funcion que sube una foto al storage
 */
export const uploadImage = async (file) => {
    try{
        const convertedFile = await imageConversion.compressAccurately(file, 0.8, "webp");

        const blob = new Blob([await convertedFile.arrayBuffer()], { type: "image/webp" });

        const fileRef = ref(storage, `images/${convertedFile.name}`);

        uploadBytes(fileRef, blob).then((snapshot) => {
            console.log('Uploaded a blob or file!', snapshot);
            alert("Imagen subida correctamente");
        });
    } catch (error) {
        console.error(error);
        return false;
    }
}

export const getServicios = async () => {
    try {
        const servicios = collection(db, "servicios");
        const querySnapshot = await getDocs(servicios);
        let serviciosArray = [];
        querySnapshot.forEach((doc) => {
            let servicio = doc.data();
            servicio.id = doc.id;
            serviciosArray.push(servicio);
        });
        return serviciosArray;
    } catch (error) {
        console.error(error);
        return null;
    }
}


export const getForosByUser = async (userId) => {
    try {
        const foros = collection(db, "forum");
        const q = query(foros, where("autor", "==", userId));
        const querySnapshot = await getDocs(q);
        let forosArray = [];
        querySnapshot.forEach((doc) => {
            let foro = doc.data();
            foro.id = doc.id;
            forosArray.push(foro);
        });
        return forosArray;
    } catch (error) {
        console.error(error);
        return null;
    }
}


export const contactForm = async (name, email, msg) => {
    try {
        const contact = collection(db, "contact");
        const newContact = await setDoc(doc(contact), {
            name: name,
            email: email,
            msg: msg
        });
        return true;
    }   catch (error) {
        console.error(error);
        return false;
    }
}


export { db, auth, analytics, storage };